import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { MentorMappingModel, MentorPost } from "common/models/page-models/mentor-mapping/mentor-mapping-model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class MentorMappingFormDataService extends FormDataService<MentorMappingModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addMentorMapping, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.getMentorMappingDataById,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        // console.log(data);
        let payload;
        payload = {
            mentorMappingId: data.id,
            
        }
        return payload;
    }

    createInstance(): MentorMappingModel {
        return new MentorMappingModel();
    }

    override modifyAPIResponse(response: any) {
        // console.log(response);
        const data = response['detail'];
        data['mentorId'] = parseInt(data['mentorId']);
        return response['detail'];
    }

    override getPostDataType(): boolean {
        return false;
    }

    // override modifyModel(model: any, metamodel?: any) {
    //     console.log(model, metamodel);
    //     const payload = {
    //         mentorId: model.mentorId,
    //         student_ids: model.student_ids
    //     }
    //     return payload;
    // }

    // override beforePostData(model: MentorMappingModel, metamodel: any, dataModel: any): Promise<MentorMappingModel> {
    //     return new Promise<MentorMappingModel>((resolve, reject) => {
    //         resolve(this.modifyPostModel(this.transformModel(model, metamodel), dataModel));
    //       });
    // }


    override getUpdateUrl() {
        return API_URL.editMentorMapping;
    }

    override modifyPostModel(formModel: any, dataModel: any) {
        // console.log(formModel);
        // const formData = new FormData();
        // formData.append('mentorId', formModel.mentorId);
        // formModel.student_ids.forEach(id => formData.append('student_ids[]', id));
        // console.log(formModel);
        
        const mentorPost = new MentorPost();
        mentorPost.mentorId = formModel.mentorId;
        mentorPost.student_ids = formModel.student_ids;

        return mentorPost;
    }

}